{{#with attributes}}
  <{{semantic-heading-level}} class="{{typography-scale}}{{#if display}} {{display}}{{/if}}">
    {{t locale-key}}
  </{{semantic-heading-level}}>
{{/with}}